// removed by extract-text-webpack-plugin
module.exports = {"container":"_2gyDi","textMessage":"AOzha"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomMessage/CustomMessage.less
// module id = 548
// module chunks = 0